export const FETCH_LIS_CASE_REQUEST = "@@lis/FETCH_LIS_CASE_REQUEST";
export const FETCH_LIS_CASE_SUCCESS = "@@lis/FETCH_LIS_CASE_SUCCESS";
export const FETCH_LIS_CASE_FAILURE = "@@lis/FETCH_LIS_CASE_FAILURE";

export const UPDATE_LIS_CASE_REQUEST = "@@lis/UPDATE_LIS_CASE_REQUEST";
export const UPDATE_LIS_CASE_SUCCESS = "@@lis/UPDATE_LIS_CASE_SUCCESS";
export const UPDATE_LIS_CASE_FAILURE = "@@lis/UPDATE_LIS_CASE_FAILURE";

export const UPLOAD_LIS_DOCUMENT_REQUEST = "@@lis/UPLOAD_LIS_DOCUMENT_REQUEST";
export const UPLOAD_LIS_DOCUMENT_SUCCESS = "@@lis/UPLOAD_LIS_DOCUMENT_SUCCESS";
export const UPLOAD_LIS_DOCUMENT_FAILURE = "@@lis/UPLOAD_LIS_DOCUMENT_FAILURE";

export const UPDATE_LIS_PATIENT_REQUEST = "@@lis/UPDATE_LIS_PATIENT_REQUEST";
export const UPDATE_LIS_PATIENT_SUCCESS = "@@lis/UPDATE_LIS_PATIENT_SUCCESS";
export const UPDATE_LIS_PATIENT_FAILURE = "@@lis/UPDATE_LIS_PATIENT_FAILURE";

export const UPDATE_LIS_LOCATION_REQUEST = "@@lis/UPDATE_LIS_LOCATION_REQUEST";
export const UPDATE_LIS_LOCATION_SUCCESS = "@@lis/UPDATE_LIS_LOCATION_SUCCESS";
export const UPDATE_LIS_LOCATION_FAILURE = "@@lis/UPDATE_LIS_LOCATION_FAILURE";

export const CREATE_LIS_INSURANCE_REQUEST =
  "@@lis/CREATE_LIS_INSURANCE_REQUEST";
export const CREATE_LIS_INSURANCE_SUCCESS =
  "@@lis/CREATE_LIS_INSURANCE_SUCCESS";
export const CREATE_LIS_INSURANCE_FAILURE =
  "@@lis/CREATE_LIS_INSURANCE_FAILURE";

export const UPDATE_LIS_INSURANCE_REQUEST =
  "@@lis/UPDATE_LIS_INSURANCE_REQUEST";
export const UPDATE_LIS_INSURANCE_SUCCESS =
  "@@lis/UPDATE_LIS_INSURANCE_SUCCESS";
export const UPDATE_LIS_INSURANCE_FAILURE =
  "@@lis/UPDATE_LIS_INSURANCE_FAILURE";

export const DELETE_LIS_INSURANCE_REQUEST =
  "@@lis/DELETE_LIS_INSURANCE_REQUEST";
export const DELETE_LIS_INSURANCE_SUCCESS =
  "@@lis/DELETE_LIS_INSURANCE_SUCCESS";
export const DELETE_LIS_INSURANCE_FAILURE =
  "@@lis/DELETE_LIS_INSURANCE_FAILURE";

export const CREATE_LIS_SLIDE_REQUEST = "@@lis/CREATE_LIS_SLIDE_REQUEST";
export const CREATE_LIS_SLIDE_SUCCESS = "@@lis/CREATE_LIS_SLIDE_SUCCESS";
export const CREATE_LIS_SLIDE_FAILURE = "@@lis/CREATE_LIS_SLIDE_FAILURE";

export const UPDATE_LIS_SLIDE_REQUEST = "@@lis/UPDATE_LIS_SLIDE_REQUEST";
export const UPDATE_LIS_SLIDE_SUCCESS = "@@lis/UPDATE_LIS_SLIDE_SUCCESS";
export const UPDATE_LIS_SLIDE_FAILURE = "@@lis/UPDATE_LIS_SLIDE_FAILURE";

export const DELETE_LIS_SLIDE_REQUEST = "@@lis/DELETE_LIS_SLIDE_REQUEST";
export const DELETE_LIS_SLIDE_SUCCESS = "@@lis/DELETE_LIS_SLIDE_SUCCESS";
export const DELETE_LIS_SLIDE_FAILURE = "@@lis/DELETE_LIS_SLIDE_FAILURE";

export const CREATE_LIS_SPECIMEN_REQUEST = "@@lis/CREATE_LIS_SPECIMEN_REQUEST";
export const CREATE_LIS_SPECIMEN_SUCCESS = "@@lis/CREATE_LIS_SPECIMEN_SUCCESS";
export const CREATE_LIS_SPECIMEN_FAILURE = "@@lis/CREATE_LIS_SPECIMEN_FAILURE";

export const UPDATE_LIS_SPECIMEN_REQUEST = "@@lis/UPDATE_LIS_SPECIMEN_REQUEST";
export const UPDATE_LIS_SPECIMEN_SUCCESS = "@@lis/UPDATE_LIS_SPECIMEN_SUCCESS";
export const UPDATE_LIS_SPECIMEN_FAILURE = "@@lis/UPDATE_LIS_SPECIMEN_FAILURE";

export const DELETE_LIS_SPECIMEN_REQUEST = "@@lis/DELETE_LIS_SPECIMEN_REQUEST";
export const DELETE_LIS_SPECIMEN_SUCCESS = "@@lis/DELETE_LIS_SPECIMEN_SUCCESS";
export const DELETE_LIS_SPECIMEN_FAILURE = "@@lis/DELETE_LIS_SPECIMEN_FAILURE";
